import React, { Component } from "react";
import pinyin from "pinyin";
import { Col, Container, Row } from "react-bootstrap";
//import { getEntries } from "chinese-lexicon";

import DisplayCharacter from "./DisplayCharacter";
import WriteChinese from "./WriteChinese";
import VoiceButton from "../../VoiceButton/VoiceButton";

class LearnAndWrite extends Component {

  getMultiplePinYin = (char) => {
    //console.log(getEntries(this.props.character))
    return pinyin(char, {
      heteronym: true
    })[0].join(",  ");
  }
  render() {
    return (
      <Container>
        <Row>
          <Col sx={4}>
            <DisplayCharacter character={this.props.character} uid={0}/>
          </Col>
          <Col sx={8}>
            <h1 className="text-primary">
              <VoiceButton 
                text={this.props.character}
                lang="zh-CN"
                displayedChars={this.props.character}
              />
            </h1>
            <h5>拼音： {this.getMultiplePinYin(this.props.character)}</h5>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sx={4}>
            <WriteChinese character={this.props.character} uid={1}/>
          </Col>
          <Col sx={4}>
            <WriteChinese character={this.props.character} uid={2}/>
          </Col>
          <Col sx={4}>
            <WriteChinese character={this.props.character} uid={3}/>
          </Col>
          <Col sx={4}>
            <WriteChinese character={this.props.character} uid={4} showOutline={false}/>
          </Col>
          <Col sx={4}>
            <WriteChinese character={this.props.character} uid={5} showOutline={false}/>
          </Col>
          <Col sx={4}>
            <WriteChinese character={this.props.character} uid={6} showOutline={false}/>
          </Col>
        </Row>
      </Container>
    );
  }

  static defaultProps = {
    character: "鸾"
};
}



export default LearnAndWrite;